<div
  id="contexto-card"
  [ngClass]="{
    'm-3': true,
    'rounded-xl': true,
    'shadow-md': true,
    'hover:shadow-lg': true,
    'shadow-xl': !!contexto && contextoExpandido,
    'transition-all': true,
    'duration-300': true,
    'overflow-hidden': true,
    'border': true,
    'border-orange-200': !contexto || !contextoExpandido,
    'border-orange-300': !!contexto && contextoExpandido,
    'dark:border-orange-900': !contexto || !contextoExpandido,
    'dark:border-orange-800': !!contexto && contextoExpandido,
    'bg-gradient-to-br': true,
    'from-white': true,
    'via-orange-50': true,
    'to-amber-50': true,
    'dark:from-slate-800': true,
    'dark:via-slate-800': true,
    'dark:to-slate-900': true
  }"
>
  <!-- Com contexto: resumo + expandir -->
  <ng-container *ngIf="contexto">
    <!-- Header do Card (sempre visível) -->
    <div
      id="contexto-header"
      class="flex items-start justify-between px-3.5 py-3 cursor-pointer hover:bg-gradient-to-br hover:from-orange-50 hover:via-orange-100 hover:to-amber-50 dark:hover:from-slate-700 dark:hover:via-slate-700 dark:hover:to-slate-800 transition-all duration-200"
      (click)="toggleContexto()"
    >
      <div class="flex-1 min-w-0 space-y-2">
        <!-- Estabelecimento -->
        <div id="contexto-estabelecimento" class="flex items-center gap-2.5">
          <div
            class="flex-shrink-0 w-5 h-5 rounded-md border border-orange-500 dark:border-orange-400 flex items-center justify-center"
          >
            <lucide-icon name="home" class="w-3 h-3 text-orange-600 dark:text-orange-400"></lucide-icon>
          </div>
          <p class="text-base font-bold text-gray-900 dark:text-white truncate leading-tight tracking-tight">
            {{ contexto.estabelecimento?.nome || contexto.estabelecimento?.descricao || '-' }}
          </p>
        </div>

        <!-- Turma -->
        <div id="contexto-turma" class="flex items-center gap-2.5">
          <div
            class="flex-shrink-0 w-5 h-5 rounded-md border border-orange-500 dark:border-orange-400 flex items-center justify-center"
          >
            <lucide-icon name="users" class="w-3 h-3 text-orange-600 dark:text-orange-400"></lucide-icon>
          </div>
          <p class="text-sm font-semibold text-gray-700 dark:text-gray-200 truncate tracking-normal">
            {{ contexto.turma?.descricao || contexto.turma?.nome || '-' }}
          </p>
        </div>

        <!-- Ano Letivo -->
        <div id="contexto-ano-letivo" class="flex items-center gap-2.5">
          <div
            class="flex-shrink-0 w-5 h-5 rounded-md border border-orange-500 dark:border-orange-400 flex items-center justify-center"
          >
            <lucide-icon name="calendar" class="w-3 h-3 text-orange-600 dark:text-orange-400"></lucide-icon>
          </div>
          <p class="text-sm font-medium text-gray-600 dark:text-gray-300 truncate tracking-wide">
            {{ contexto.anoLetivo?.ano || '-' }}
          </p>
        </div>
      </div>

      <div class="flex items-center flex-shrink-0 ml-3">
        <button
          id="contexto-toggle-btn"
          class="flex items-center justify-center w-8 h-8 rounded-lg bg-orange-100 dark:bg-slate-700 text-orange-700 dark:text-orange-400 hover:bg-orange-200 dark:hover:bg-slate-600 transition-all duration-200"
          aria-label="Expandir/Recolher contexto"
          title="{{ contextoExpandido ? 'Recolher' : 'Expandir' }}"
        >
          <lucide-icon [name]="contextoExpandido ? 'chevron-up' : 'chevron-down'" class="w-5 h-5"></lucide-icon>
        </button>
      </div>
    </div>

    <!-- Conteúdo Expansível -->
    <div id="contexto-expandivel" class="transition-all duration-300 ease-in-out" [class.hidden]="!contextoExpandido">
      <div class="px-4 pb-4 pt-2 space-y-3 border-t border-gray-100 dark:border-gray-700 bg-blue-50/50 dark:bg-blue-900/5">
        <!-- Entidade -->
        <div id="contexto-entidade" class="text-sm">
          <span class="text-gray-500 dark:text-gray-400 font-medium">Entidade:</span>
          <p class="text-gray-900 dark:text-gray-100 font-medium break-words">
            {{ contexto.entidade?.nome || contexto.entidade?.name || '-' }}
          </p>
        </div>

        <!-- Servidor -->
        <div id="contexto-servidor" class="text-sm">
          <span class="text-gray-500 dark:text-gray-400 font-medium">Servidor:</span>
          <p class="text-gray-900 dark:text-gray-100 font-medium break-words">
            {{ contexto.servidor?.pessoa?.nome || '-' }}
          </p>
        </div>

        <!-- Componentes Curriculares -->
        <div id="contexto-componentes" class="text-sm" *ngIf="getComponentesLength() > 0">
          <span class="text-gray-500 dark:text-gray-400 font-medium block mb-1.5">Componentes curriculares:</span>
          <div class="space-y-1.5">
            <div
              *ngFor="let componente of contexto.componentes; let i = index"
              [attr.id]="'contexto-componente-' + componente.id"
              class="flex items-center space-x-2"
            >
              <div
                class="w-2.5 h-2.5 rounded-full flex-shrink-0"
                [style.background-color]="getComponenteColor(componente, i)"
              ></div>
              <span class="text-gray-900 dark:text-gray-100 break-words">{{ componente.descricao || componente.nome }}</span>
            </div>
          </div>
        </div>

        <!-- Botão Alterar Contexto -->
        <button
          id="contexto-alterar-btn"
          (click)="abrirModalContexto()"
          class="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 hover:from-blue-600 hover:to-blue-700 dark:hover:from-blue-700 dark:hover:to-blue-800 text-white rounded-lg transition-all duration-200 shadow-sm font-medium text-sm"
          [attr.aria-label]="contextActionLabel"
        >
          <lucide-icon name="arrow-left-right" class="w-4 h-4"></lucide-icon>
          <span>{{ contextActionLabel }}</span>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Sem contexto: apenas resumo compacto (instruções e CTA ficam no AppComponent, abaixo do card) -->
  <div *ngIf="!contexto" id="contexto-card-vazio" class="px-3.5 py-3 flex items-center gap-2.5">
    <div
      class="flex-shrink-0 w-5 h-5 rounded-md border border-orange-500 dark:border-orange-400 flex items-center justify-center"
    >
      <lucide-icon
        name="info"
        class="w-3.5 h-3.5 text-orange-600 dark:text-orange-400"
        aria-hidden="true"
      ></lucide-icon>
    </div>
    <p class="text-sm font-semibold text-gray-700 dark:text-gray-300">Nenhum contexto selecionado</p>
  </div>
</div>
